import { css } from "lit";

export default css`
       .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .title {
            text-align: center;
            margin-top: 10px;
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }

        .header img {
            width: 70%;
            height: 80%;
            image-rendering: pixelated;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
            width: auto;
        }

        .content-text {
            overflow: auto;
            white-space: pre-wrap;
        }

        .content {
            flex-grow: 1;
            overflow: auto;
            margin-top: auto;
            padding: 0 10px;
            max-height: 100%;
            margin-bottom: auto;
        }


        .content p {
            overflow-x: hidden;
            margin: 0 0 10px 0;
        }

        .content p:last-of-type {
            margin: 0;
        }

        .footer {
            border-radius: 10px 10px 0 0;
            background-color: #151501;
            border: 2px solid #e1d816;
            margin-top: 10px;
            display: flex;
            height: 150px;
        }

        .footer .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 10px 10px 0 10px;
            justify-content: space-around;
        }

        .footer .button {
            background-color: #151501;
            border: 1px solid #e1d816;
            border-radius: 0.2rem;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }

        .footer .button.active,
        .footer .button:hover {
            background-color: #9c9723;
        }

          
                .text_input {
            display: flex;
        }

        .input_field {
            width: 75%;
        }

        .input_button {
            width: 25%;
        }
        .phonto {
        width: 800px;
        height: 400px;
        position: absolute;
       
        margin-right: 40px;
        margin-left :70px;
        z-index: 1; /* Zorg ervoor dat de .phonto bovenaan wordt gestapeld */
        }

        .key, .book, .magnifying-glass, .ster, .AricCharacter, .greenKey, .redKey, .blueKey {
        position: absolute;
        z-index: 2; /* Zorg ervoor dat de items bovenop de .phonto worden gestapeld */
        }


    .key {
        width: 60px;
        margin-left: 280px;
        padding-right: 70px;
    }

    .book{
        width: 30px;
        margin-left: 530px;
        margin-top: 360px;
    }
    .magnifying-glass{
        width: 35px;

        margin-left: 800px;
    }
    .ster {
        width: 30px;
        margin-left: 730px;
        margin-top: 340px;
    }
    .AricCharacter{
        height: 150px;
        margin-left: 430px;
        margin-top: 240px;
    }
    .redKey {
        width: 100px;
        margin-left: -180px;
        margin-top:380px;
    }.greenKey {
        width: 100px;
        margin-left: -380px;
        margin-top:400px;
    }
    .blueKey {
        width: 100px;
        margin-left: -580px;
        margin-top:400px;
    }
    .endroom2{
        width:600px;
        height:450px;
        margin-left: 200px;
        z-index: 1;
    }


        /* TODO: Ik wil zo graag een typewriter effect maken :( */
        @keyframes typing {
            0% {
                width: 0;
            } 100% {
                width: 100%;
            }
        }`; 
